<template>
  <TransitionPage>
    <router-view />
  </TransitionPage>
</template>

<script>
import TransitionPage from "@/components/TransitionPage";

export default {
  name: "Transactions",
  components: { TransitionPage }
};
</script>

<style scoped lang="scss">
@import "Transactions";
</style>
